import { CircleApi } from '@calm/evexia-web-sdk/generated/lib/api/circle-api';
import { createApi } from './create-api';

/**
 * Helper function to configure and create a new instance of an `CircleApi`
 * @param accessToken
 * @returns
 */
export default function createCircleApi(accessToken: () => Promise<string>) {
    return createApi(CircleApi, accessToken);
}
